// Needs to match the name of flags in Unleash @ https://eu.app.unleash-hosted.com/eubb1003/projects/iris
export enum FeatureFlag {
  internalCourier = 'F_INTERNAL_COURIER',
  XlFlorists = 'F_XL_FLORISTS',
  groupDocument = 'F_GROUP_DOCUMENT',
  PagedOrdersList = 'F_PAGED_ORDERS_LIST',
}

export function isFeatureFlagActive(flagName: FeatureFlag): boolean {
  const { $unleash } = useNuxtApp();
  if (!$unleash) return false;
  return $unleash.isEnabled(flagName);
}
